import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';

export const initialState = {
  loading: false,
  events: [],
  totalCount: 0,
  pageNum: 1
};

// A slice
const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    getEvents: (state, action) => {
      state.events = action.payload.events;
      state.totalCount = action.payload.totalCount;
    },
    removeEventFromEventList: (state, action) => {
      let tempEvents = state.events;
      tempEvents = tempEvents.filter((event) => event.id !== action.payload);
      state.events = tempEvents;
      state.totalCount = state.totalCount - 1;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    }
  }
});

// Actions generated from the slice
const { getEvents, removeEventFromEventList, startLoading, stopLoading } = eventsSlice.actions;

// export user selector to get the slice in any component
export const eventsSelector = (state) => state.events;

// export The reducer
const eventsReducer = eventsSlice.reducer;

export default eventsReducer;

// Actions

export const fetchEvents = (url) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await fetchWrapper.get(url);
    dispatch(
      getEvents({
        events: response.results || response.data?.results || response.data?.data,
        totalCount: response?.data?.count || response.count
      })
    );
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
export const handleRemoveEventFromEventsList = (id) => async (dispatch) => {
  try {
    dispatch(removeEventFromEventList(id));
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
export const handleEventsChanges =
  ({ index, eventState, activeTab, pageSize, isMtot, isVirtual, isPhysical, eventType }) =>
  async (dispatch) => {
    try {
      dispatch(startLoading());
      // let url = '/all-event/';
      let url;
      url = '/event/';
      if (activeTab === 'my_events') {
        url = '/my-events/';
      }
      if (pageSize) {
        url += `?limit=${pageSize}`;
      } else {
        url += `?limit=50`;
      }

      if (eventState) {
        url += `&type=${eventState}`;
      }
      if (index) {
        url += `&page=${index}`;
      }
      if (isMtot) {
        url += '&mtot=true';
      }
      if (isVirtual) {
        url += '&nature=online';
      }
      if (isPhysical) {
        url += '&nature=physical';
      }
      if (eventType && eventType !== 'clear') {
        url += `&program_type=${eventType}`;
      }

      const response = await fetchWrapper.get(url);
      const { results, count } = response.data;
      dispatch(getEvents({ events: results, totalCount: count }));
      dispatch(stopLoading(false));
    } catch (error) {
      dispatch(stopLoading(false));
      ErrorMessageHandler(error);
    }
  };
